module.exports = __webpack_public_path__ + "img/money.f875d957.svg";